import { SPENT_ON_APPLIANCE_ACTIONS } from '../../actions/spentOnApplianceActions';

const spentOnApplianceReducer = (state = {
  chartsLoaded: 0,
  chartsToBeLoaded: 0,
  imageLoaded: 0,
  imagesToBeLoaded: 1,
  hvacUsageData: null,
  usageEvent: null
}, action) => {
  switch (action.type) {
    case SPENT_ON_APPLIANCE_ACTIONS.FETCH_DATA:
      state = {
        ...state,
        hvacUsageData: action.payload,
        usageEvent: 'FETCH_DATA_DONE'
      };
      break;
    case SPENT_ON_APPLIANCE_ACTIONS.CHART_LOADED:
      state = {
        ...state,
        chartsLoaded: state.chartsLoaded + 1,
        usageEvent: 'CHART_LOADED'
      };
      break;
    case SPENT_ON_APPLIANCE_ACTIONS.UPDATE_CHARTS_TO_BE_LOADED:
      state = {
        ...state,
        chartsToBeLoaded: state.chartsToBeLoaded + 1,
        usageEvent: 'CHARTS_TO_BE_LOADED'
      };
      break;
    case SPENT_ON_APPLIANCE_ACTIONS.IMAGE_LOADED:
      state = {
        ...state,
        imageLoaded: state.imageLoaded + 1,
        usageEvent: 'IMAGE_LOADED'
      };
      break;
    case SPENT_ON_APPLIANCE_ACTIONS.IMAGES_TO_BE_LOADED:
      state = {
        ...state,
        imagesToBeLoaded: state.imagesToBeLoaded + 1,
        usageEvent: 'IMAGES_TO_BE_LOADED'
      };
      break;
    default:
      break;
  }
  return state;
};

export default spentOnApplianceReducer;
